import { Component, Input, OnInit, ViewChild, ElementRef } from "@angular/core";
import { bodyTextRecipe, BodyTextRecipeRecipe, BodyTextRecipeVariantProps } from "@fenderdigital/ui-styled-system/recipes";

import { BaseComponent, UserService, EventBusService } from "@mypxplat/xplat/core";
import { css, cx } from "styled-system/css";

@Component({
  selector: "fui-body-text",
  templateUrl: "body-text.component.html",
  standalone: false,
})
export class FuiBodyTextComponent extends BaseComponent implements OnInit {
  public usePanda: boolean = false;
  @Input() text: string;
  @Input() props: BodyTextRecipeVariantProps = {};
  @Input() color: string;
  @Input() extraClasses: string;
  @Input() size: string = "medium";
  bodyTextRecipe = bodyTextRecipe;
  public value: any;

  constructor(userService: UserService) {
    super(userService);
  }

  ngOnInit(): void {
    if (this.usePanda) {
      if (this.color) {
        this.value = cx(this.bodyTextRecipe({ ...this.props }), css({ color: this.color }));
      } else {
        this.value = this.bodyTextRecipe(this.props);
      }
    } else {
      this.value = "fui-body-" + this.size;
    }
    if (this.extraClasses) {
      this.value = this.value + " " + this.extraClasses;
    }
  }
}
